<template xmlns="http://www.w3.org/1999/html">
  <div class="index">
    <div class="contain">
      <div class="contain_toop">
        尊敬的顾客:<br/>
        为了提升平台整体的服务水平，欢迎您填写本次问卷。您所填写的问卷一经采纳，将会获得丰厚现金奖励，公司会第一时间主动和您取得联系。我们将会对您的信息完全保密，非常感谢您对平台的支持与帮助。我们会持续努力的打造客户更为满意的平台，为您提供更优质的服务。
      </div>

      <div class="Head_step_bar">
        <el-steps :active="active" align-center>
          <el-step title="基础信息"></el-step>
          <el-step title="平台体验"></el-step>
          <el-step title="中医自测"></el-step>
          <el-step title="其他建议"></el-step>
        </el-steps>
      </div>
      <!--  基础信息    -->
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="demo-ruleForm"
               :label-position="labelPosition">
        <div class="basic_Info" v-if="active === 1">
          <div class="basic_Info_title">一、基础信息</div>
          <el-form-item label="客户名称：" prop="name">
            <el-input disabled v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="联系方式：" prop="contactInfo">
            <el-input v-model="ruleForm.contactInfo"></el-input>
          </el-form-item>
          <el-form-item label="性别：" prop="sex">
            <el-radio-group disabled v-model="ruleForm.sex">
              <el-radio label="男"></el-radio>
              <el-radio label="女"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="年龄：" prop="age">
            <el-select disabled v-model="ruleForm.age" placeholder="请选择">
              <el-option
                v-for="(item, index) in 100"
                :key="index"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市：" prop="city">
            <el-cascader
              placeholder="请选择"
              v-model="ruleForm.city"
              :options="options"
            ></el-cascader>
          </el-form-item>
        </div>
        <!--  平台体验   -->
        <div class="platform_Experience" v-if="active === 2">
          <div class="basic_Info_title">二、平台体验</div>
          <div class="platform_Experience_left">
            <div class="platform_Experience_title"><span class="xin">*</span>首页风格</div>
            <div>
              <el-form-item label="手机APP界面" prop="appInterface">
                <div class="box_layout">
                  <div>
                    <el-radio-group v-model="ruleForm.appInterface">
                      <el-radio label="漂亮">漂亮</el-radio>
                      <el-radio label="一般">一般</el-radio>
                      <el-radio label="难看">难看</el-radio>
                      <el-radio label="其他">其他</el-radio>
                    </el-radio-group>
                  </div>
                  <div>
                    <el-input class="elInput" ref="appInterfaceOtherContext"
                              v-model="ruleForm.appInterfaceOtherContext"></el-input>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="电脑端界面" prop="pcInterface">
                <div class="box_layout">
                  <div>
                    <el-radio-group v-model="ruleForm.pcInterface">
                      <el-radio label="漂亮">漂亮</el-radio>
                      <el-radio label="一般">一般</el-radio>
                      <el-radio label="难看">难看</el-radio>
                      <el-radio label="其他">其他</el-radio>
                    </el-radio-group>
                  </div>
                  <div>
                    <el-input class="elInput" ref="pcInterfaceOtherContext"
                              v-model="ruleForm.pcInterfaceOtherContext"></el-input>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="platform_Experience_left">
            <div class="platform_Experience_title"><span class="xin">*</span>其他页面</div>
            <div>
              <el-form-item label="" prop="otherInterface">
                <div class="box_layout">
                  <div>
                    <el-radio-group v-model="ruleForm.otherInterface">
                      <el-radio label="漂亮">漂亮</el-radio>
                      <el-radio label="一般">一般</el-radio>
                      <el-radio label="难看">难看</el-radio>
                      <el-radio label="其他">其他</el-radio>
                    </el-radio-group>
                  </div>
                  <div>
                    <el-input class="elInput" ref="otherInterfaceOtherContext"
                              v-model="ruleForm.otherInterfaceOtherContext"></el-input>
                  </div>
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="platform_Experience_left">
            <div class="platform_Experience_title"><span class="xin">*</span>平台速度</div>
            <div>
              <el-form-item label="" prop="platformSpeed">
                <el-radio-group v-model="ruleForm.platformSpeed">
                  <el-radio label="快">快</el-radio>
                  <el-radio label="一般">一般</el-radio>
                  <el-radio label="慢">慢</el-radio>
                </el-radio-group>
              </el-form-item>
            </div>
          </div>
        </div>
        <!--  中医自测功能   -->
        <div class="self_diagnosis" v-if="active === 3">
          <div class="basic_Info_title">三、中医自测功能</div>
          <div>
            <div>
              <div></div>
              <div>
                <el-form-item label="自测流程" prop="selfDiagnosisProcess">
                  <div class="box_layout">
                    <div>
                      <el-radio-group v-model="ruleForm.selfDiagnosisProcess">
                        <el-radio label="便捷">便捷</el-radio>
                        <el-radio label="繁琐">繁琐</el-radio>
                        <el-radio label="一般">一般</el-radio>
                        <el-radio label="其他">其他</el-radio>
                      </el-radio-group>
                    </div>
                    <div>
                      <el-input class="elInput" ref="selfDiagnosisProcessOtherContext"
                                v-model="ruleForm.selfDiagnosisProcessOtherContext"></el-input>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div>
              <div></div>
              <div>
                <el-form-item label="自测过程中症状选项是否齐全" prop="selfDiagnosisProcessOption">
                  <div class="box_layout">
                    <div>
                      <el-radio-group v-model="ruleForm.selfDiagnosisProcessOption">
                        <el-radio label="非常全">非常全</el-radio>
                        <el-radio label="很全">很全</el-radio>
                        <el-radio label="一般">一般</el-radio>
                        <el-radio label="其他">其他</el-radio>
                      </el-radio-group>
                    </div>
                    <div>
                      <el-input class="elInput" ref="selfDiagnosisProcessOptionOtherContext"
                                v-model="ruleForm.selfDiagnosisProcessOptionOtherContext"></el-input>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div>
              <div></div>
              <div>
                <el-form-item label="诊断结果准确度" prop="diagnosticAccuracy">
                  <div class="box_layout">
                    <div>
                      <el-radio-group v-model="ruleForm.diagnosticAccuracy">
                        <el-radio label="非常准">非常准</el-radio>
                        <el-radio label="一般准">一般准</el-radio>
                        <el-radio label="不准">不准</el-radio>
                        <el-radio label="其他">其他</el-radio>
                      </el-radio-group>
                    </div>
                    <div>
                      <el-input class="elInput" ref="diagnosticAccuracyOtherContext"
                                v-model="ruleForm.diagnosticAccuracyOtherContext"></el-input>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
            <div>
              <div></div>
              <div>
                <el-form-item label="其他功能使用的建议" prop="functionAdvise">
                  <el-input v-model="ruleForm.functionAdvise"></el-input>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <!--  其他建议   -->
        <div class="Other_Tips" v-if="active === 4">
          <div class="basic_Info_title">四、中医自测功能</div>
          <div>
            <div></div>
            <div>
              <el-form-item label="中医讲堂" prop="zyjtAdvise">
                <el-input v-model="ruleForm.zyjtAdvise"></el-input>
              </el-form-item>
            </div>
          </div>
          <div>
            <div></div>
            <div>
              <el-form-item label="中药大全" prop="zydqAdvise">
                <el-input v-model="ruleForm.zydqAdvise"></el-input>
              </el-form-item>
            </div>
          </div>
          <div>
            <div></div>
            <div>
              <el-form-item label="中医文库" prop="zywkAdvise">
                <el-input v-model="ruleForm.zywkAdvise"></el-input>
              </el-form-item>
            </div>
          </div>
          <div>
            <div></div>
            <div>
              <el-form-item label="经络穴位" prop="jlxwAdvise">
                <el-input v-model="ruleForm.jlxwAdvise"></el-input>
              </el-form-item>
            </div>
          </div>
          <div>
            <div></div>
            <div>
              <el-form-item label="中药药城" prop="zyycAdvise">
                <el-input v-model="ruleForm.zyycAdvise"></el-input>
              </el-form-item>
            </div>
          </div>
          <div>
            <div></div>
            <div>
              <el-form-item label="其他问题" prop="otherAdvise">
                <el-input v-model="ruleForm.otherAdvise"></el-input>
              </el-form-item>
            </div>
          </div>
        </div>
      </el-form>
      <div class="btn">
        <el-button v-if="isShow" type="warning" @click="nextStep">下一步</el-button>
        <el-button v-else type="warning" @click="save">提交</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import cityList from '@/common/cityList.js'
import {getBirthdayFromIdCard, getAgeFromBirthday} from "@/common/birthday";

export default {
  name: 'questionnaire',
  data() {
    //  验证手机号码
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("联系方式不能为空"));
      } else {
        const reg = /^1[3-9][0-9]\d{8}$/;
        // 这里定义的reg变量没有加引号，所以是一种特殊的数据类型，即正则，可以直接用test()方法
        if (reg.test(value)) {
          callback();
        } else {
          // 具体错误信息没有提示
          return callback(new Error("请输入正确的联系方式"));
        }
      }
    };
    // 验证其他原因
    var checkFrequency = (rule, value, callback) => {
      let other = this.$refs.selfDiagnosisProcessOtherContext.value
      if (!value) {
        return callback(new Error("请选择自测流程"));
      } else if (value == '其他') {
        if (!other) {
          return callback(new Error("请输入内容"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    var checkFrequencysel = (rule, value, callback) => {
      let other = this.$refs.selfDiagnosisProcessOptionOtherContext.value
      if (!value) {
        return callback(new Error("请选择自测过程中症状选项是否齐全"));
      } else if (value == '其他') {
        if (!other) {
          return callback(new Error("请输入内容"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    var checkFrequencyDiag = (rule, value, callback) => {
      let other = this.$refs.diagnosticAccuracyOtherContext.value
      if (!value) {
        return callback(new Error("请选择诊断结果准确度"));
      } else if (value == '其他') {
        if (!other) {
          return callback(new Error("请输入内容"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    var checkAppInterface = (rule, value, callback) => {
      let other = this.$refs.appInterfaceOtherContext.value
      if (!value) {
        return callback(new Error("请选择手机App界面"));
      } else if (value == '其他') {
        if (!other) {
          return callback(new Error("请输入内容"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    var checkPcInterface = (rule, value, callback) => {
      let other = this.$refs.pcInterfaceOtherContext.value
      if (!value) {
        return callback(new Error("请选择客户端界面"));
      } else if (value == '其他') {
        if (!other) {
          return callback(new Error("请输入内容"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }
    var checkOtherInterface = (rule, value, callback) => {
      let other = this.$refs.otherInterfaceOtherContext.value
      if (!value) {
        return callback(new Error("请选择其他页面"));
      } else if (value == '其他') {
        if (!other) {
          return callback(new Error("请输入内容"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    }

    return {
      labelPosition: 'right',
      active: 1,
      isShow: true,
      options: cityList,
      rules: {
        name: [
          {required: true, message: '请输入客户名称', trigger: 'blur'},
          {min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur'}
        ],
        contactInfo: [
          {required: true, validator: checkPhone, trigger: 'blur'}
        ],
        sex: [
          {required: true, message: '请选择性别', trigger: 'blur'},
        ],
        age: [
          {required: true, message: '请选择年龄', trigger: 'blur'},
        ],
        city: [
          {required: true, message: '请选择城市', trigger: 'blur'},
        ],
        platformSpeed: [
          {required: true, message: '请选择平台速度', trigger: 'blur'},
        ],
        appInterface: [
          {validator: checkAppInterface, trigger: 'blur'},
        ],
        pcInterface: [
          {validator: checkPcInterface, trigger: 'blur'},
        ],
        otherInterface: [
          {required: true, validator: checkOtherInterface, trigger: 'blur'},
        ],
        selfDiagnosisProcess: [
          {required: true, validator: checkFrequency, trigger: 'blur'},
        ],
        selfDiagnosisProcessOption: [
          {required: true, validator: checkFrequencysel, trigger: 'blur'},
        ],
        diagnosticAccuracy: [
          {required: true, validator: checkFrequencyDiag, trigger: 'blur'},
        ],
        functionAdvise: [
          {required: false, message: '请输入其他功能使用的建议', trigger: 'blur'},
        ],
        zyitAdvise: [
          {required: false, message: '请输入中医讲堂', trigger: 'blur'},
        ],
        zydgAdvise: [
          {required: false, message: '请输入中药大全', trigger: 'blur'},
        ],
        zywkAdvise: [
          {required: false, message: '请输入中医文库', trigger: 'blur'},
        ],
        jlxwAdvise: [
          {required: false, message: '请输入经络穴位', trigger: 'blur'},
        ],
        zyycAdvise: [
          {required: false, message: '请输入中药药城', trigger: 'blur'},
        ],
        otherAdvise: [
          {required: false, message: '请输入其他问题', trigger: 'blur'},
        ]
      },
      ruleForm: {
        name: '',
        contactInfo: '',
        sex: '男',
        age: '',
        city: '',
        platformSpeed: '',
        appInterface: '',
        appInterfaceOtherContext: '',
        pcInterface: '',
        pcInterfaceOtherContext: '',
        otherInterface: '',
        otherInterfaceOtherContext: '',
        selfDiagnosisProcess: '',
        selfDiagnosisProcessOtherContext: '',
        selfDiagnosisProcessOption: '',
        selfDiagnosisProcessOptionOtherContext: '',
        diagnosticAccuracy: '',
        diagnosticAccuracyOtherContext: '',
        functionAdvise: '',
        zyjtAdvise: '',
        zydqAdvise: '',
        zywkAdvise: '',
        jlxwAdvise: '',
        zyycAdvise: '',
        otherAdvise: ''
      }
    }
  },
  mounted() {
    let obj = JSON.parse(sessionStorage.getItem("userInfo"))
    this.ruleForm.name = obj.username
    this.ruleForm.age = this.mymethod(obj.birthday);
    this.getSex(obj.idCard)
  },
  methods: {
    getSex(idCard) {
      if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
        this.ruleForm.sex = "男";
      } else {
        this.ruleForm.sex = "女";
      }
    },
    // 根据日期算年龄
    mymethod(birthday) {
      if (birthday) {
        birthday = birthday.split('-');
        let date = new Date();
        let today = [date.getFullYear(), date.getMonth() + 1, date.getDate()];
        let age = today.map((val, index) => {
          return val - birthday[index]
        })
        if (age[2] < 0) {
          let lastMonth = new Date(today[0], today[1], 0)
          age[1]--
          age[2] += lastMonth.getDate()
        }
        if (age[1] < 0) {
          age[0]--
          age[1] += 12
        }
        return age[0]
        console.log(age[0] + '岁' + age[1] + '月' + age[2] + '天');
      }
    },

    nextStep() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.active = this.active + 1
          if (this.active === 4) {
            this.isShow = false
          }
        }
      });
    },
    save() {
      let that = this;
      that.ruleForm.city = that.ruleForm.city.toString()
      let params = that.ruleForm;
      let url = "/questionnaire/save";
      that.$http
        .post(url, params)
        .then(res => {
          if (res.data.code == 200) {
            that.$message.success(res.data.msg);
            window.close()
            // this.$router.push({ path: '/index'})
          } else {
            that.$message.error(res.data.msg);
          }
        })

    }

  }
}
</script>
<style scoped>

.Head_step_bar {
  margin: 3% 0;
  width: 100%;
}

.basic_Info .platform_Experience .self_diagnosis .Other_Tips {
  margin: 0 7%;
}

.basic_Info_title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
}

.platform_Experience_title {
  font-size: 18px;
  font-weight: 500;
}

.platform_Experience_left {
  margin-left: 7.5%;
}

.btn {
  margin-top: 5%;
  text-align: center;
  width: 100%;
}

.box_layout {
  display: flex;
}

.elInput {
  margin-left: 20px;
}

/deep/ .el-radio__inner {
  border: 1px solid #7c7f85;
}

/deep/ .el-form-item {
  margin-left: 5%;
  margin-bottom: 18px;
}

/deep/ .el-form--label-top .el-form-item__label {
  padding: 0;
}

/deep/ .el-select {
  width: 100%;
}

/deep/ .el-cascader {
  width: 100%;
}

/deep/ .el-radio {
  min-width: 100px;
  margin-righ: 0;
}

.xin {
  content: '*';
  color: #F56C6C;
  margin-right: 4px;
}

.contain_toop {
  margin-top: 10px;
  font-size: 15px;
  line-height: 33px;
}
/deep/ .el-radio__label  {
  color: #000 !important;
}
/deep/ .el-radio__input.is-disabled .el-radio__inner, .el-radio__input.is-disabled.is-checked .el-radio__inner {
  background-color: #d5d0d0  !important;
  border-color: #6d6d6d  !important;
}
/deep/ .el-radio__input.is-disabled.is-checked .el-radio__inner::after {
  background-color: #292a2e;
}
</style>



// WEBPACK FOOTER //
// src/components/common/questionnaire.vue